import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';
import './Login.css';
import logo from './assets/newlogo.png';
import dukkan from './assets/dukkan.jpg';
import dukkan2 from './assets/dukkan2.jpg';

const slideImages = [dukkan, dukkan2];

export default function PersonnelSignupPage() {
  const navigate = useNavigate();
  const [slideIndex, setSlideIndex] = useState(0);
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const id = window.setInterval(() => {
      setSlideIndex((i) => (i + 1) % slideImages.length);
    }, 6500);
    return () => window.clearInterval(id);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    const trimmedEmail = email.trim().toLowerCase();
    const trimmedName = fullName.trim();
    if (!trimmedName || !trimmedEmail || !password) return;

    setLoading(true);
    const { error: signUpError } = await supabase.auth.signUp({
      email: trimmedEmail,
      password,
      options: {
        data: { full_name: trimmedName, role: 'barista' },
      },
    });
    setLoading(false);

    if (signUpError) {
      setError(signUpError.message);
      return;
    }

    setSuccess('Kayit olusturuldu. E-posta dogrulamasi sonrasi giris yapip barista paneline gidebilirsiniz.');
    setTimeout(() => navigate('/login', { replace: true }), 1200);
  };

  return (
    <div className="login-page">
      <div className="login-content">
        <div className="login-left">
          <div className="login-header">
            <img src={logo} alt="" className="login-logo" />
            <h1>Personel Sign Up</h1>
            <p>Yeni personel hesabi olusturun.</p>
          </div>

          <form className="login-form" onSubmit={handleSubmit} noValidate>
            <div className="login-form-group" style={{ '--index': 1 }}>
              <label htmlFor="fullName">Full name</label>
              <div className="login-input-with-icon">
                <svg className="login-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                <input
                  id="fullName"
                  name="fullName"
                  type="text"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  placeholder="Ad Soyad"
                  required
                  disabled={loading}
                />
              </div>
            </div>

            <div className="login-form-group" style={{ '--index': 2 }}>
              <label htmlFor="email">Email address</label>
              <div className="login-input-with-icon">
                <svg className="login-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                  disabled={loading}
                />
              </div>
            </div>

            <div className="login-form-group" style={{ '--index': 3 }}>
              <label htmlFor="password">Password</label>
              <div className="login-input-with-icon">
                <svg className="login-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0110 0v4" />
                </svg>
                <input
                  id="password"
                  name="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Minimum 6 karakter"
                  minLength={6}
                  required
                  disabled={loading}
                />
              </div>
            </div>

            {error ? <div className="login-error" role="alert">{error}</div> : null}
            {success ? <div className="login-error" role="status" style={{ background: '#dcfce7', color: '#166534' }}>{success}</div> : null}

            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? 'Olusturuluyor…' : 'Personel hesabi olustur'}
            </button>

            <p style={{ marginTop: 12, fontSize: 14, color: '#64748b' }}>
              Hesabin var mi? <Link to="/login">Sign in</Link>
            </p>
          </form>
        </div>

        <div className="login-right">
          <div className="login-right-visual" aria-hidden>
            {slideImages.map((src, i) => (
              <img key={src} src={src} alt="" className={`login-right-slide-img ${i === slideIndex ? 'active' : ''}`} />
            ))}
          </div>
          <div className="login-right-scrim" aria-hidden />
          <div className="login-right-content" />
        </div>
      </div>
    </div>
  );
}
